import { render, staticRenderFns } from "./SiiDisconnect.vue?vue&type=template&id=4be47d3c"
import script from "./SiiDisconnect.vue?vue&type=script&lang=js"
export * from "./SiiDisconnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports